export class DealPageHelper {    

    static showTextInputSuccessMsg(selectorOrElement, successMsg) {
        var element = selectorOrElement;
        if (element.nodeName == undefined) {//it's not element        
            element = document.querySelector(selectorOrElement);
        }
        element.nextElementSibling.innerHTML = successMsg;
        element.nextElementSibling.style.display = "block";        
        element.nextElementSibling.style.color = "green";        
    }

    static showElement(selector) {
        let element = selector;
        if (selector.nodeName == undefined) {
            element = document.querySelector(selector);
        }
        element.style.display = "block";
    }
    
    static hideElement(selector) {
        let element = selector;
        if (selector.nodeName == undefined) {
            element = document.querySelector(selector);
        }
        element.style.display = "none";
    }

    static showTextInputError(selectorOrElement, errorMsg) {
        var element = selectorOrElement;
        if (element.nodeName == undefined) {//it's not element        
            element = document.querySelector(selectorOrElement);
        }
        element.nextElementSibling.innerHTML = errorMsg;
        element.nextElementSibling.style.display = "block";        
        element.nextElementSibling.style.color = "#ee0000";//red
    }

    static hideTextInputError(selectorOrElement) {
        var element = selectorOrElement;
        if (element.nodeName == undefined) {//it's not element        
            element = document.querySelector(selectorOrElement);
        }
        element.nextElementSibling.style.display = "none";        
    }

    static hideError(elem) {
        elem = elem.querySelector(".error-input");
        elem.style.display = "none";
    }

    static showElement(selector) {
        let element = selector;
        if (selector.nodeName == undefined) {
            element = document.querySelector(selector);
        }
        element.style.display = "block";
    }

    static hideElement(selector) {
        let element = selector;
        if (selector.nodeName == undefined) {
            element = document.querySelector(selector);
        }
        element.style.display = "none";
    }

    static isEmpty(elem) {
        let empty = elem.value.length == 0 ? true : false;
        return empty;
    }

    static focus(elem) {
        elem.focus();
        elem.select();
    }

    static isChecked(elem) {
        return elem.checked;
    }

    static isValidEmail(email) {
        let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    static isValidPhoneNumber(phoneNumber) {
        if (phoneNumber.length == 12) {
            let regex = /^[2-9]{1}[0-9]{2}[-][2-9]{1}[0-9]{2}[-][0-9]{4}$/;
            return regex.test(phoneNumber);
        }
        let regex = /^\d{1}-\d{3}-\d{3}-\d{4}$|^\d{3}-\d{3}-\d{4}$/;
        return regex.test(phoneNumber);
    }

    static convertPrice(x) {
        var p = String(x);
        var i = p.length - 2;
        return p.slice(0, i) + "." + p.slice(i);
    }
}
